import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { googleLogin } from "../api/googleAuthApi";
import jwtTokenService from "../services/jwtTokenService";

const GoogleSignInButton = ({ onSuccess, text = "Sign in with Google" }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const initializeGoogleButton = () => {
      if (!window.google || !window.google.accounts) {
        return;
      }

      try {
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: handleGoogleResponse,
          ux_mode: "popup",
          auto_select: false,
        });

        window.google.accounts.id.renderButton(
          document.getElementById("google-signin-button"),
          {
            theme: "outline",
            size: "large",
            width: "100%",
            text: text,
            shape: "rectangular",
            logo_alignment: "left",
          }
        );
      } catch (error) {
        console.error("Error initializing Google Sign-In button:", error);
      }
    };

    // Check if script already exists
    const existingScript = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
    
    if (existingScript) {
      initializeGoogleButton();
    } else {
      // Load Google Identity Services script
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.onload = initializeGoogleButton;
      document.body.appendChild(script);
    }
  }, [text]);

  const handleGoogleResponse = async (response) => {
    try {
      const result = await googleLogin(response.credential);

      if (result.data.success) {
        // Save token
        jwtTokenService.setToken(result.data.token);
        
        // Save user info
        if (result.data.user) {
          localStorage.setItem("trivana_user", JSON.stringify(result.data.user));
        }

        toast.success(`Welcome ${result.data.user?.name || 'User'}! 🎉`);

        // Dispatch login event
        window.dispatchEvent(
          new CustomEvent("login", {
            detail: { user: result.data.user },
          })
        );

        // Call onSuccess callback if provided
        if (onSuccess) {
          onSuccess(result.data);
        } else {
          // Default: redirect to home
          setTimeout(() => {
            navigate("/");
            window.location.reload();
          }, 500);
        }
      }
    } catch (error) {
      console.error("Google login failed:", error);
      toast.error(
        error.response?.data?.message || "Google login failed. Please try again."
      );
    }
  };

  return (
    <div 
      id="google-signin-button" 
      style={{ 
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    ></div>
  );
};

export default GoogleSignInButton;
